import { initConsentUi } from './ui';
(() => {
    initConsentUi();
})();
